module.exports = __webpack_public_path__ + "static/media/Logo.83cfce35.png";